module.exports = {
  apiKey: "AIzaSyDiYXKnzaUL06PASkcQcrMHuRS7_HaT4mo",
  authDomain: "ante-think.firebaseapp.com",
  projectId: "ante-think",
  storageBucket: "ante-think.appspot.com",
  messagingSenderId: "472408142930",
  appId: "1:472408142930:web:37254380dd7ea5882a5b8b",
  measurementId: "G-DCWN1B307E",
};
